import { axios } from "./http";
//实例接口
const api = (params = {}) => {
  return axios.get("/api", {
    params,
  });
};
const apiPost = (params = {}) => {
  return axios.post("/api", params);
};
//获取部门列表
export const getDeptList = (params = {}) => {
  return axios.get("/app-api/rule/module-config/getDeptListById",{params})
};
//修改当个数据
export const updateSingle = (data = {}) => {
  return axios.put("/app-api/inspection/info/updateSingle", data);
}
//检查是否推送
export const checkIsPush = (params = {}) => {
  return axios.post(`app-api/platform-pay/purchase-validate`, params);
};
//扫码加入切换租户接口
export const switchTenant = (params = {}) => {
  return axios.post(`/app-api/member/tenant/join-tenant?tenantId=${params.tenantId}`,   );
}
//扫码预览报告信息接口
export const previewReport = (params = {}) => {
  return axios.get("/app-api/report/receive/preview", { params });
}
//预览pdf
export const isview = (params = {}) => {
  return axios.get("/app-api/report/receive/isView", { params });
}
//获取流程数信息 3级流程/4级流程
export const getProcessNum = (params = {}) => {
  return axios.get("/app-api/inspection/info/getInfoNode", { params });
};
//验证是否收费接口
export const validateIsCharge = (params = {}) => {
  return axios.post("/app-api/platform-pay/purchase-validate", params);
};
//获取钱包余额接口
export const getWalletBalance = (params = {}) => {
  return axios.get("/app-api/platform-pay/get-wallet", { params });
};
//获取服务价格接口
export const getServicePrice = (params = {}) => {
  return axios.post("/app-api/platform-pay/get-price", params);
};
//购买服务接口
export const purchaseService = (params = {}) => {
  return axios.post("/app-api/platform-pay/submit-item-order", params);
};
//箱号列表
export const getBoxList_yqx = (params = {}) => {
  return axios.get("/app-api/inspection/instrument-box/simpleListByInfo", { params });
}
//箱号关联仪器列表
export const getBoxInstrumentList_yqx = (params = {}) => {
  return axios.get("/app-api/jyjc/deploy-instrument/getListByInfo", { params });
}
